import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { ParticipantsFailure, ParticipantsRequest, ParticipantsSuccess } from './actions';
import { ParticipantsService } from './service';
import { getData } from './selectors';

@Injectable()
export class ParticipantsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly participantsService = inject(ParticipantsService);

  participants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParticipantsRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.participantsService.participants(parameters).pipe(
            map(data => ParticipantsSuccess({ data })),
            catchError(error => of(ParticipantsFailure({ error })))
          );
        }
        return of(ParticipantsSuccess({ data }));
      })
    )
  );

}
